import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle, pmlSettingPageStyle } from './PLMSettingStyle';
import { PLM_CSV_SET } from './PLMSetting';
import Button from '@material-ui/core/Button';
import PLMSettingGridRow from './PLMSettingGridRow';
import { useTranslation } from 'react-i18next';

type PLMSettingGridProps = {
  plmSettingList: PLM_CSV_SET[];
  onClickDeleteButton: (indexNo: number) => void;
  onChangeData: (targetRow: PLM_CSV_SET) => void;
};

const PLMSettingGrid: React.FC<PLMSettingGridProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const plmStyle = pmlSettingPageStyle();
  const { t, i18n } = useTranslation();

  return (
    <TableContainer component={Paper} className={plmStyle.tableContainer}>
      <Table stickyHeader aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell className={tableStyle.headerCell}>{'No'}</TableCell>
            <TableCell className={tableStyle.headerCell}>{t('PLMSettingGrid.PLM名称', 'PLM名称')}</TableCell>
            <TableCell className={tableStyle.headerCell}>
              {t('PLMSettingGrid.保存先フォルダ', '保存先フォルダ')}
            </TableCell>
            <TableCell className={tableStyle.headerCell}>{t('PLMSettingGrid.ユーザID', 'ユーザID')}</TableCell>
            <TableCell className={tableStyle.headerCell}>{t('PLMSettingGrid.パスワード', 'パスワード')}</TableCell>
            <TableCell className={tableStyle.headerCell}>{t('PLMSettingGrid.IPアドレス', 'IPアドレス')}</TableCell>
            <TableCell className={tableStyle.headerCell}>{t('PLMSettingGrid.送信時間', '送信時間')}</TableCell>
            <TableCell className={tableStyle.headerCell}> {t('PLMSettingGrid.手動送信', '手動送信')}</TableCell>
            <TableCell className={tableStyle.headerCell}> {t('PLMSettingGrid.ステータス', 'ステータス')}</TableCell>
            <TableCell className={tableStyle.headerCell}> {t('PLMSettingGrid.削除', '削除')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.plmSettingList.map((row, index) => {
            return (
              <PLMSettingGridRow
                key={index}
                plmSetting={row}
                rowIndexNo={row.indexNo}
                onClickDeleteButton={props.onClickDeleteButton}
                onChangeData={props.onChangeData}
              ></PLMSettingGridRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PLMSettingGrid;
